/**
 * Gộp các dòng cấu hình duyệt trùng `step` (BE đôi khi trả nhiều record cùng bước).
 * Union `owners` và loại trùng theo `id`.
 */
export function mergeApprovalConfigDetailsByStep(details) {
  if (!Array.isArray(details) || !details.length) return [];
  const byStep = new Map();
  for (const d of details) {
    const step = Number(d?.step);
    if (!Number.isFinite(step)) continue;
    if (!byStep.has(step)) {
      byStep.set(step, { ...d, owners: [...(d.owners || [])] });
    } else {
      const cur = byStep.get(step);
      cur.owners = [...(cur.owners || []), ...(d.owners || [])];
    }
  }
  return [...byStep.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([, detail]) => {
      const ownerSeen = {};
      const owners = [];
      for (const o of detail.owners || []) {
        if (!o || o.id == null || ownerSeen[o.id]) continue;
        ownerSeen[o.id] = true;
        owners.push(o);
      }
      return { ...detail, owners };
    });
}
